import AddIcon from "@mui/icons-material/Add";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Badge,
  Checkbox,
  ClickAwayListener,
  FormControlLabel,
  Grow,
  Link,
  MenuItem,
  Paper,
  Popper,
  Tab,
  Tooltip,
} from "@mui/material";
import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { DateTime } from "luxon";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { exportEventLogCSV } from "../../../axios/Eventlog/EventLogApi";
import CardListIcon14pxSvg from "../../../assets/images/icons/CardListIcon14pxSvg";
import ClockIcon14pxSvg from "../../../assets/images/icons/ClockIcon14pxSvg";
import CloudArrowDownIcon16pxSvg from "../../../assets/images/icons/CloudArrowDownIcon16pxSvg";
import CloudArrowUpIcon16pxSvg from "../../../assets/images/icons/CloudArrowUpIcon16pxSvg";
import ImageIcon14pxSvg from "../../../assets/images/icons/ImageIcon14pxSvg";
import AddUndefindedImageIcon16pxSvg from "../../../assets/images/icons/AddUndefindedImageIcon16pxSvg";
import ReplayIcon from "@mui/icons-material/Replay";
import Combobox from "../../../components/Combobox";
import CustomAutocomplete from "../../../components/CustomAutocomplete";
import CustomSelect from "../../../components/CustomSelect";
import CustomSelectShiftReport from "../../../components/CustomSelectShiftReport";
import CustomSplitButton from "../../../components/CustomSplitButton";
import CustomTimePicker from "../../../components/CustomTimePickerHaveSecond";
import {
  CustomAdvancedMenuList,
  CustomTabPanel,
  CustomTabsV2,
} from "../../../components/StyledComponents";
import { LoadingProvider, useLoading } from "../../../context/LoadingContext";
import { useAuth } from "../../../context/AuthContext";
import { getListUserGroup } from "../../../axios/Group/GroupUrlApi";
import RequestIcon14pxSvg from "./../../../assets/images/icons/RequestIcon14Svg.svg";
import RequestIcon14pxBlueSvg from "./../../../assets/images/icons/RequestIcon14BlueSvg.svg";
import EventsGridInfoTable from "./EventsGridInfoTable";
import RequestGridInfoTable from "./RequestGridInfoTable";
import EventImagesGridInfoTable from "./EventImagesGridInfoTable";
import EventLogMonthEventsCalendar from "./EventLogMonthEventsCalendar";
import RequestMonthCalendar from "./RequestMonthCalendar";
import EventImagesCalendar from "./EventImagesCalendar";
import EventLogChart from "./EventLogChart";
import OvertimeTab from "./OvertimeTab";
import { useNotification } from "../../../context/NotificationContext";
import { ControlpanelPrimaryButton, ControlpanelPurple2thButton, ControlpanelSuccessButton } from "../../../components/StyledButton";
import AlarmFillIcon14pxSvg from "../../../assets/images/icons/AlarmFillIcon14pxSvg";
import DefaultTooltip from "../../../components/DefaultTooltip";
import QuestionIcon16pxSvgWhite from "../../../assets/images/icons/QuestionIcon16pxSvgWhite";
import RestoreV2Icon16pxSvg from "../../../assets/images/icons/RestoreV2Icon16pxSvg";
import ImportIcon16pxSvg from "../../../assets/images/icons/ImportIcon16pxSvg";
import ExportIcon16pxSvg from "../../../assets/images/icons/ExportIcon16pxSvg";

dayjs.extend(utc);
dayjs.extend(timezone);

const buildFromToByDateWithTZ = (selectedDate, timeZone) => {
  const base = DateTime.fromISO(
    typeof selectedDate === "string"
      ? selectedDate
      : DateTime.fromJSDate(selectedDate).toISODate(),
    { zone: timeZone }
  );

  return {
    from: base.startOf("day").toUTC().toISO(),
    to: base.endOf("day").toUTC().toISO(),
  };
};

const a11yProps = (index) => ({
  id: `event-log-tab-${index}`,
  "aria-controls": `event-log-tabpanel-${index}`,
});

const EventLogTabs = ({
  isShowErrorLog,
  isShowEnableLog,
  onRowSelection,
  onRefresh,
  refreshData,
  selectedDate,
  selectedShift,
  selectedUser,
  setSelectedUser,
  setSelectedDate,
  setSelectedShift,
  setSelectedDevice,
  setSelectedGroup,
  setIsShowErrorLog,
  setIsShowErrorIMG,
  getTabName,
  usersData,
  isShowErrorIMG,
  selectDevice,
  selectStartTime,
  selectEndTime,
  setSelectStartTime,
  setSelectEndTime,
  formatEventFilter,
  onErrorUsersChange,
  errorUserIds,
  selectGroup,
  dispalyWeek,
  groupData,
  shiftsData,
  devicesData,
  dialogRef,
  calculateDisplayedWeeks,
}) => {
  const { isAdmin, isEmployee, profile, dateTimeFormat, genaralSettingTimeZone } = useAuth();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const { notifications } = useNotification();
  const [showLoading, hideLoading] = useLoading();
  const [searchParams] = useSearchParams();
  const [tabValue, setTabValue] = useState(0);
  const [showSummary, setShowSummary] = useState(true);
  const [userGroup, setUserGroup] = useState([]);
  const [userGroup1, setUserGroup1] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [showOnlyPendingRequests, setShowOnlyPendingRequests] = useState(false);

  const pendingRequestCount = notifications.filter(
    (n) => n.unread && n.type === "EVENTLOG"
  ).length;

  const anchorRefAddEvent = useRef(null);
  const anchorRefAddRequest = useRef(null);
  const [openAddEventMenu, setOpenAddEventMenu] = useState(false);
  const [openAddRequestMenu, setOpenAddRequestMenu] = useState(false);

  const allShiftIds = shiftsData.map((shift) => shift.shiftId);
  const allDeviceIds = devicesData.map((device) => device.deviceId);

  const [formData, setFormData] = useState({
    shift: allShiftIds,
    device: allDeviceIds,
    group: groupData?.[0]?.id ?? 1,
    startTime: selectStartTime || "00:00:00",
    endTime: selectEndTime || "23:59:00",
  });

  const statusData = [
    { eventStatusId: 0, eventStatusName: t("common.all-status") },
    { eventStatusId: 1, eventStatusName: t("attendance.CHECK_IN") },
    { eventStatusId: 2, eventStatusName: t("attendance.CHECK_OUT") },
    { eventStatusId: 3, eventStatusName: t("attendance.PENDING_CHECK_IN") },
    { eventStatusId: 4, eventStatusName: t("attendance.PENDING_CHECK_OUT") },
  ];

  useEffect(() => {
    if (shiftsData?.length > 0) {
      setFormData((prev) => ({
        ...prev,
        shift: allShiftIds,
        device: allDeviceIds,
      }));
    }
  }, [shiftsData, devicesData]);

  useEffect(() => {
    getTabName(tabValue);
  }, [tabValue, getTabName]);

  useEffect(() => {
    const requestIdParam = searchParams.get("requestId");
    if (!requestIdParam) return;
    setTabValue(1);
    getTabName?.(1);
  }, [searchParams, getTabName]);

  const handleChangeTab = (event, newValue) => {
    if (newValue === 3) return;
    setTabValue(newValue);
  };

  const getUserLabel = useCallback(
    (option) => t("common.content-158", option),
    [t]
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "group") {
      setFormData((prev) => ({ ...prev, group: value }));
      setSelectedGroup?.(value);
      return;
    }

    if (name === "shift") {
      const selected = Array.isArray(value) ? value : [value];
      const realShifts = shiftsData.filter((s) => s.shiftId !== 0);

      if (realShifts.length === 1) {
        const onlyShiftId = realShifts[0].shiftId;
        setFormData((prev) => ({
          ...prev,
          shift: [0, onlyShiftId],
        }));
        return;
      }

      const isSelectingAll = selected.includes(0);
      const wasSelectingAll = formData.shift.includes(0);

      if (isSelectingAll && !wasSelectingAll) {
        const allIds = [...new Set([0, ...shiftsData.map((s) => s.shiftId)])];
        setFormData((prev) => ({ ...prev, shift: allIds }));
      } else if (!isSelectingAll && wasSelectingAll) {
        setFormData((prev) => ({ ...prev, shift: [] }));
      } else if (wasSelectingAll && isSelectingAll) {
        setFormData((prev) => ({ ...prev, shift: [] }));
      } else if (!wasSelectingAll && !isSelectingAll) {
        if (formData.shift.length === 0) {
          setFormData((prev) => ({
            ...prev,
            shift: [selected[selected.length - 1]],
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            shift: [selected[selected.length - 1]],
          }));
        }
      }
      return;
    }

    if (name === "device") {
      const selected = Array.isArray(value) ? value : [value];
      const isSelectingAll = selected.includes(0);
      const wasSelectingAll = formData.device.includes(0);

      if (isSelectingAll && !wasSelectingAll) {
        const allIds = [...new Set([0, ...devicesData.map((d) => d.deviceId)])];
        setFormData((prev) => ({ ...prev, device: allIds }));
      } else if (!isSelectingAll && wasSelectingAll) {
        setFormData((prev) => ({ ...prev, device: [] }));
      } else if (wasSelectingAll && isSelectingAll) {
        setFormData((prev) => ({ ...prev, device: [] }));
      } else if (!wasSelectingAll && !isSelectingAll) {
        if (formData.device.length === 0) {
          setFormData((prev) => ({
            ...prev,
            device: [selected[selected.length - 1]],
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            device: [selected[selected.length - 1]],
          }));
        }
      }
      return;
    }

    if (name === "eventStatusId") {
      setSelectedStatus(value);
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    setSelectedShift(formData.shift.includes(0) ? 0 : formData.shift.join(","));
    setSelectedDevice(
      formData.device.includes(0) ? 0 : formData.device.join(",")
    );
  }, [formData, setSelectedShift, setSelectedDevice]);

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        group: formData.group,
        pageNo: 1,
        recordPerPage: 50000,
        langId: localStorage.getItem("i18nextLngId"),
      };
      try {
        const response = await getListUserGroup(payload);
        setUserGroup(response.data.data);
      } catch (error) {
        if (error.response?.status !== 401) {
          toast.error(t(error?.response?.data.message));
        }
      }
    };
    fetchData();
  }, [formData.group, t]);

  useEffect(() => {
    const fetchData1 = async () => {
      const payload = {
        group: 1,
        pageNo: 1,
        recordPerPage: 50000,
        langId: localStorage.getItem("i18nextLngId"),
      };
      try {
        const response = await getListUserGroup(payload);
        setUserGroup1(response.data.data);
      } catch (error) {
        if (error.response?.status !== 401) {
          toast.error(t(error?.response?.data.message));
        }
      }
    };
    fetchData1();
  }, [t]);

  const handleDataChange = (name, newData) => {
    if (name === "startTime") setSelectStartTime(newData);
    if (name === "endTime") setSelectEndTime(newData);
    setFormData((prev) => ({ ...prev, [name]: newData }));
  };

  const handleCloseAddEventMenu = (event) => {
    if (anchorRefAddEvent.current?.contains(event.target)) return;
    setOpenAddEventMenu(false);
  };

  const handleCloseAddRequestMenu = (event) => {
    if (anchorRefAddRequest.current?.contains(event.target)) return;
    setOpenAddRequestMenu(false);
  };

  const handleErrorUsersChange = (payload) => {
    onErrorUsersChange?.(payload);
  };

  const isPastSelectedDate = useMemo(() => {
    if (!selectedDate) return false;

    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return selected < today;
  }, [selectedDate]);

  useEffect(() => {
    if (!isPastSelectedDate && isShowErrorLog) {
      setIsShowErrorLog(false);
    }
  }, [isPastSelectedDate, isShowErrorLog, setIsShowErrorLog]);

  const hasErrorRows =
    isShowErrorLog &&
    ((errorUserIds?.missingCheckInUserIds?.length || 0) > 0 ||
      (errorUserIds?.missingCheckOutUserIds?.length || 0) > 0);

  const handleOpenAddMissingCheckout = () => {
    if (!hasErrorRows) return;

    const shiftIds = formData.shift?.filter((id) => id !== 0) || [];
    dialogRef?.current?.openAddMissingCheckout?.(shiftIds);
  };

  const getCurrentTimestamp = () => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const MM = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const HH = String(now.getHours()).padStart(2, "0");
    const mm = String(now.getMinutes()).padStart(2, "0");
    const ss = String(now.getSeconds()).padStart(2, "0");
    return `${yyyy}${MM}${dd}${HH}${mm}${ss}`;
  };

  const exportEventLogs = async () => {
    setOpenAddEventMenu(false);

    const timeZone = genaralSettingTimeZone || dayjs.tz.guess() || "UTC";
    const { from, to } = buildFromToByDateWithTZ(selectedDate, timeZone);

    let shiftIds = selectedShift;
    if (shiftIds === 0 || shiftIds === "0" || shiftIds === "all") {
      shiftIds = "";
    }

    const payload = {
      from,
      to,
      userId: isAdmin ? (selectedUser?.id ?? 0) : profile.userId,
      groupId: selectGroup ?? formData.group,
      shiftIds,
      isError: isShowErrorLog,
      isEnabled: isShowEnableLog,
      langId: localStorage.getItem("i18nextLngId"),
      lang: currentLang,
      formatDate: dateTimeFormat,
      timeZone,
      recordPerPage: 500,
    };

    try {
      showLoading();
      const response = await exportEventLogCSV(payload);

      if (response) {
        const blob = new Blob([response.data], { type: "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${t("drawer.event-log")}_${getCurrentTimestamp()}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      if (error.response?.status !== 401) {
        toast.error(t(error?.response?.data) || t("common.something-went-wrong"));
      } else if (!error.response) {
        toast.error(t("common.network-timeout"));
      }
    } finally {
      hideLoading();
    }
  };

  const renderAddEventMenu = () => (
    <Popper
      open={openAddEventMenu}
      anchorEl={anchorRefAddEvent.current}
      placement="bottom-end"
      transition
      disablePortal
      className="z-10"
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === "bottom" ? "right top" : "right bottom",
          }}
        >
          <Paper style={{ borderRadius: "8px", }} className="shadow-primary mt-1">
            <ClickAwayListener onClickAway={handleCloseAddEventMenu}>
              <CustomAdvancedMenuList id="add-event-menu">
                <MenuItem
                  style={{ borderBottom: "1px solid #E5E7EB", opacity: 0.5, pointerEvents: "none" }}
                  onClick={(e) => {
                    dialogRef?.current?.openRestoreEvents?.();
                    handleCloseAddEventMenu(e);
                  }}
                >
                  <Link>
                    <RestoreV2Icon16pxSvg />
                    <p>{t("button.restore-events")}</p>
                  </Link>
                </MenuItem>
                <MenuItem
                  style={{ borderBottom: "1px solid #E5E7EB" }}
                  onClick={(e) => {
                    dialogRef?.current?.openSelectDataToImport?.();
                    handleCloseAddEventMenu(e);
                  }}
                >
                  <Link>
                    <ImportIcon16pxSvg />
                    <p>{t("button.import-data")}</p>
                  </Link>
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    exportEventLogs();
                    handleCloseAddEventMenu(e);
                  }}
                >
                  <Link>
                    <ExportIcon16pxSvg />
                    <p>{t("button.export-data")}</p>
                  </Link>
                </MenuItem>
              </CustomAdvancedMenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );

  const renderAddRequestMenu = () => (
    <Popper
      open={openAddRequestMenu}
      anchorEl={anchorRefAddRequest.current}
      placement="bottom-end"
      transition
      disablePortal
      className="z-10"
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === "bottom" ? "right top" : "right bottom",
          }}
        >
          <Paper style={{ borderRadius: "8px", }} className="shadow-primary mt-1">
            <ClickAwayListener onClickAway={handleCloseAddRequestMenu}>
              <CustomAdvancedMenuList id="add-request-menu">
                <MenuItem
                  style={{ borderBottom: "1px solid #E5E7EB" }}
                  onClick={(e) => {
                    dialogRef?.current?.openAddRequest?.();
                    handleCloseAddRequestMenu(e);
                  }}
                >
                  <Link>
                    <AddIcon className="!text-[20px]" />
                    <p>{t("common.request")}</p>
                  </Link>
                </MenuItem>
              </CustomAdvancedMenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );

  const renderEventsFilters = () => (
    <div className="flex flex-col lg:flex-row lg:items-center gap-3 w-full px-4 ">
      <div className="flex flex-1 min-w-0 flex-wrap lg:flex-nowrap items-stretch gap-3">
        {isAdmin && (
          <CustomAutocomplete
            className="w-full min-w-0 flex-1 basis-[180px]"
            name="user"
            options={userGroup}
            placeholder={t("common.content-161")}
            dataType="user"
            freeSolo={true}
            value={selectedUser}
            onDataChange={(_, value) => {
              window.history.replaceState({}, "");
              setSelectedUser(value);
            }}
          />
        )}
        {isAdmin && (
          <CustomSelect
            name="group"
            id="group"
            value={formData.group}
            onChange={handleInputChange}
            options={groupData}
            dataType="group"
            className="w-full min-w-0 flex-1 basis-[180px]"
          />
        )}
        <CustomSelectShiftReport
          multiple
          name="shift"
          value={formData.shift}
          onChange={handleInputChange}
          options={shiftsData}
          dataType="shift"
          className="w-full min-w-0 flex-1 basis-[180px]"
        />
      </div>
      <div className="flex items-center gap-3 shrink-0 flex-wrap justify-end">
        {/* {renderAddRequestButton()} */}
        {(isEmployee || isAdmin) && (
          <ControlpanelPurple2thButton
            type="button"
            className="text-[#2563EB] text-sm font-medium whitespace-nowrap"
            onClick={() => dialogRef?.current?.openCheckInOut?.()}
          >
            <AlarmFillIcon14pxSvg className="fill-[#A855F7]" />
            {t("common.content-112")}
          </ControlpanelPurple2thButton>
        )}
        {isAdmin && (
          <div className="relative">
            <CustomSplitButton
              label={t("common.add-events")}
              startIcon={<AddIcon />}
              onMainClick={() => dialogRef?.current?.openAddEvent?.()}
              onDropdownClick={() => setOpenAddEventMenu((prev) => !prev)}
              ref={anchorRefAddEvent}
            />
            {renderAddEventMenu()}
          </div>
        )}
      </div>
    </div>
  );

  const renderRequestsFilters = () => (
    <div className="flex flex-col lg:flex-row lg:items-center gap-3 w-full px-4">
      <div className="flex flex-1 min-w-0 flex-wrap lg:flex-nowrap items-stretch gap-3">
        {isAdmin && (
          <CustomAutocomplete
            className="w-full min-w-0 flex-1 basis-[180px]"
            name="user"
            options={userGroup}
            placeholder={t("common.content-161")}
            dataType="user"
            freeSolo={true}
            value={selectedUser}
            onDataChange={(_, value) => {
              window.history.replaceState({}, "");
              setSelectedUser(value);
            }}
          />
        )}
        {isAdmin && (
          <CustomSelect
            name="group"
            id="group"
            value={formData.group}
            onChange={handleInputChange}
            options={groupData}
            dataType="group"
            className="w-full min-w-0 flex-1 basis-[180px]"
          />
        )}
        <CustomSelectShiftReport
          multiple
          name="shift"
          value={formData.shift}
          onChange={handleInputChange}
          options={shiftsData}
          dataType="shift"
          className="w-full min-w-0 flex-1 basis-[180px]"
        />
      </div>
      {(isEmployee || isAdmin) && (
        <div className="relative shrink-0">
          <ControlpanelPrimaryButton
            onClick={() => dialogRef?.current?.openAddRequest?.()}
          >
            <AddIcon />
            <p className="mr-1">{t("common.add-requests")}</p>
          </ControlpanelPrimaryButton>
          {renderAddRequestMenu()}
        </div>
      )}
    </div>
  );

  const renderImagesFilters = () => (
    <div className="flex flex-col lg:flex-row lg:items-center gap-3 w-full px-4">
      <div className="flex flex-1 min-w-0 flex-wrap lg:flex-nowrap items-stretch gap-3">
        {/* <div className="flex flex-1 min-w-0 basis-[240px] items-center gap-2">
          <CustomTimePicker
            hoursLabel={false}
            onTimeChange={handleDataChange}
            value={formData.startTime}
            name="startTime"
            maxHours={23}
            className="!w-full !h-10 !flex-1"
          />
          <span className="text-gray-400 shrink-0">-</span>
          <CustomTimePicker
            hoursLabel={false}
            onTimeChange={handleDataChange}
            value={formData.endTime}
            name="endTime"
            maxHours={23}
            className="!w-full !h-10 !flex-1"
          />
        </div> */}
        {isAdmin && (
          <CustomAutocomplete
            className="w-full min-w-0 flex-1 basis-[180px]"
            name="user"
            options={userGroup}
            placeholder={t("common.content-161")}
            dataType="user"
            freeSolo={true}
            value={selectedUser}
            onDataChange={(_, value) => {
              window.history.replaceState({}, "");
              setSelectedUser(value);
            }}
          />
        )}
      </div>
      {isAdmin && (
        <div className="shrink-0">
          <ControlpanelPrimaryButton
            onClick={() => dialogRef?.current?.openAddEventFromUnidentified?.()}
          >
            <AddIcon />
            <p className="mr-1">{t("button.add-undefined-image")}</p>
          </ControlpanelPrimaryButton>
        </div>
      )}
    </div>
  );

  const renderSummary = (calendarComponent, chartType) => (
    <>
      <div
        className="flex items-center justify-between bg-white rounded-xl pt-2 px-3 sm:px-4 cursor-pointer px-4"
        onClick={() => setShowSummary((prev) => !prev)}
      >
        <span className="font-semibold text-base sm:text-lg md:text-[20px]">
          {t("common.summary")}
        </span>
        {showSummary ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      </div>

      {showSummary && (
        <div className="grid grid-cols-1 3xl:grid-cols-12 gap-3 sm:gap-4 min-w-0 px-5 py-2">
          <div className="col-span-1 3xl:col-span-9 min-w-0">
            <div className="card bg-white rounded-xl min-w-0 h-full">
              <LoadingProvider>{calendarComponent}</LoadingProvider>
            </div>
          </div>
          <div className="col-span-1 3xl:col-span-3 min-w-0">
            <div className="card bg-white rounded-xl flex justify-center items-center w-full min-w-0 h-full xl:ml-1">
              <LoadingProvider>
                <EventLogChart
                  chartType={chartType}
                  selectedDate={selectedDate}
                  selectedUser={selectedUser}
                  selectedShift={selectedShift}
                  selectGroup={selectGroup}
                  selectDevice={selectDevice}
                  selectStartTime={selectStartTime}
                  selectEndTime={selectEndTime}
                  refreshData={refreshData}
                />
              </LoadingProvider>
            </div>
          </div>
        </div>
      )}
    </>
  );

  return (
    <div className="min-w-0 w-full max-w-full">
      <Fragment>
        <CustomTabsV2
          variant="fullWidth"
          scrollButtons="auto"
          allowScrollButtonsMobile
          indicatorColor="none"
          value={tabValue}
          onChange={handleChangeTab}
        >
          <Tab
            label={
              <div className="flex items-center gap-2">
                <p className="text-sm">{t("common.events")}</p>
              </div>
            }
            {...a11yProps(0)}
            disableRipple
          />
          <Tab
            label={
              <div className="flex items-center gap-2">
                <p className={`text-sm ${tabValue === 1 ? "text-[#2563EB]" : ""}`}>
                  {t("common.request1")}
                </p>
              </div>
            }
            {...a11yProps(1)}
            disableRipple
          />
          <Tab
            disabled={!isAdmin}
            label={
              <div className="flex items-center gap-2">
                <p className="text-sm">{t("common.event-images")}</p>
              </div>
            }
            {...a11yProps(2)}
            disableRipple
          />
          <Tab
            onClick={(e) => e.preventDefault()}
            sx={{ pointerEvents: "auto", opacity: 0.5, cursor: "not-allowed" }}
            label={
              <Tooltip title={t("common.developing")} arrow>
                <div className="flex items-center gap-2">
                  <ClockIcon14pxSvg />
                  <p className="text-sm">{t("common.overtime")}</p>
                </div>
              </Tooltip>
            }
            {...a11yProps(3)}
            disableRipple
          />
        </CustomTabsV2>

        <CustomTabPanel value={tabValue} index={0}>
          {renderEventsFilters()}
          {renderSummary(
            <EventLogMonthEventsCalendar
              setSelectedDate={setSelectedDate}
              selectedDate={selectedDate}
              selectedShift={selectedShift}
              selectedUser={selectedUser}
              refreshData={refreshData}
              calculateDisplayedWeeks={calculateDisplayedWeeks}
              selectGroup={selectGroup}
            />,
            "events"
          )}
          {isPastSelectedDate && (
            <div
              className="showOnlyErrorEvents mt-1 gap-3 flex items-center justify-between px-5"
              style={{ display: isEmployee ? "none" : "" }}
            >
              <div className="flex gap-1 items-center">
                <Checkbox
                  id="showOnlyErrorEvents"
                  className="!p-0 !ml-[-3px]"
                  checked={isShowErrorLog}
                  onChange={(e) => setIsShowErrorLog(e.target.checked)}
                />
                <p className="text-sm">{t("common.show-only-error-events")}</p>
              </div>

              {isShowErrorLog && (
                <ControlpanelSuccessButton
                  disabled={!hasErrorRows}
                  onClick={handleOpenAddMissingCheckout}
                  sx={{
                    borderRadius: "8px",
                    textDecoration: "none",
                    pointerEvents: hasErrorRows ? "auto" : "none",
                    cursor: hasErrorRows ? "pointer" : "not-allowed",
                  }}
                  style={{
                    color: "#fff",
                    opacity: !hasErrorRows ? "0.5" : "1",
                  }}
                >
                  <AddIcon />
                  <p>{t("button.add-missing-checkout")}</p>
                </ControlpanelSuccessButton>
              )}
            </div>
          )}
          <div className="bg-white rounded-xl min-w-0 w-full overflow-x-auto px-4 py-2">
            <LoadingProvider>
              <EventsGridInfoTable
                isShowErrorLog={isShowErrorLog}
                isShowEnableLog={isShowEnableLog}
                selectedShift={selectedShift}
                selectedUser={selectedUser}
                selectedDate={selectedDate}
                refreshData={refreshData}
                onRefresh={onRefresh}
                onRowSelection={onRowSelection}
                formatEventFilter={formatEventFilter}
                onErrorUsersChange={handleErrorUsersChange}
                selectGroup={selectGroup}
                dispalyWeek={dispalyWeek}
                usersData={usersData}
                shiftsData={shiftsData}
              />
            </LoadingProvider>
          </div>
        </CustomTabPanel>

        <CustomTabPanel value={tabValue} index={1}>
          {renderRequestsFilters()}
          {renderSummary(
            <RequestMonthCalendar
              setSelectedDate={setSelectedDate}
              selectedDate={selectedDate}
              selectedShift={selectedShift}
              selectedUser={selectedUser}
              refreshData={refreshData}
              calculateDisplayedWeeks={calculateDisplayedWeeks}
            />,
            "requests"
          )}
          {/* <div className="mt-3 flex items-center gap-2">
          <Checkbox
            checked={showOnlyPendingRequests}
            onChange={(e) => setShowOnlyPendingRequests(e.target.checked)}
            className="!p-0"
          />
          <p className="text-sm">{t("common.pending-request")}</p>
        </div> */}
          <div className="bg-white rounded-xl min-w-0 w-full overflow-x-auto px-4 py-2">
            <LoadingProvider>
              <RequestGridInfoTable
                isShowErrorLog={showOnlyPendingRequests}
                selectedShift={selectedShift}
                selectedUser={selectedUser}
                selectedDate={selectedDate}
                refreshData={refreshData}
                onRefresh={onRefresh}
                onRowSelection={onRowSelection}
                usersData={usersData}
                shiftsData={shiftsData}
                dispalyWeek={dispalyWeek}
              />
            </LoadingProvider>
          </div>
        </CustomTabPanel>

        <CustomTabPanel value={tabValue} index={2}>
          {renderImagesFilters()}
          {renderSummary(
            <EventImagesCalendar
              setSelectedDate={setSelectedDate}
              selectedDate={selectedDate}
              selectedShift={selectedShift}
              selectedUser={selectedUser}
              refreshData={refreshData}
              isShowErrorIMG={isShowErrorIMG}
              calculateDisplayedWeeks={calculateDisplayedWeeks}
            />,
            "images"
          )}
          <div className="mt-1 flex items-center gap-2 px-4">
            <Checkbox
              checked={isShowErrorIMG}
              onChange={(e) => setIsShowErrorIMG(e.target.checked)}
              className="!p-0"
            />
            <p className="text-sm">{t("common.show-only-unknown-images")}</p>
          </div>
          <div className="bg-white rounded-xl min-w-0 w-full max-w-full overflow-hidden px-4 pb-2">
            <LoadingProvider>
              <EventImagesGridInfoTable
                isShowErrorIMG={isShowErrorIMG}
                selectDevice={selectDevice}
                selectedDate={selectedDate}
                selectEndTime={selectEndTime}
                selectStartTime={selectStartTime}
                dispalyWeek={dispalyWeek}
                refreshData={refreshData}
              />
            </LoadingProvider>
          </div>
        </CustomTabPanel>

        <CustomTabPanel value={tabValue} index={3}>
          <OvertimeTab />
        </CustomTabPanel>
      </Fragment>
    </div>
  );
};

export default EventLogTabs;
